import SettingNotify from "../components/SettingNotify";
import useSettingNotify from "../hooks/useSettingNotify";

const SettingNotifyPage = () => {
    const useSettingNotifyProps = useSettingNotify();
    return <SettingNotify {...useSettingNotifyProps} />
}

export default SettingNotifyPage;